<template>
    <div v-if="status === 'loaded'" id="expedients-list">
        <the-nav>
            <h1>Expedientes</h1>

            <div class="buttons-container">
                <button class="btn btn-primary me-4"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#expedientFilters"
                        :aria-expanded="showFilters"
                        aria-controls="expedientFilters"
                        @click="showFilters = !showFilters">
                    <span class="uq-icon bi-filter me-2"></span>
                    <template v-if="showFilters">Ocultar filtros</template>
                    <template v-else>Mostrar filtros</template>
                </button>

                <button class="btn btn-danger icon-wrapper"
                        @click="emptyFilters">
                    <span class="uq-icon bi-filter me-2"></span>
                    Limpiar filtros
                </button>

                <!-- TODO: Handle button status -->
                <button class="btn btn-download icon-wrapper"
                        v-if="can('export.seguimiento-expedientes')"
                        @click="downloadSeguimientos(filters, true)">
                    <span class="uq-icon bi-download"></span>
                </button>

                <button class="btn btn-secondary"
                        @click="modalToShow = 'add-expedient'"
                        title="Crear nuevo expediente">
                    <span>Añadir expediente</span>
                </button>
            </div>
        </the-nav>

        <div id="expedientFilters" class="expedient-filters collapse show">
            <div class="form-container mb-0 w-100" v-if="can('client.index')">
                <div class="form-wrapper mb-3">
                    <div class="form-group search-form">
                        <div class="row gx-2 w-100">
                            <div class="col-3">
                                <label
                                    class="form-label d-flex justify-content-center align-items-center bg-primary w-100 py-1 me-0 mb-0">
                                    Nº cliente:
                                </label>
                            </div>

                            <div class="col-3">
                                <v-select
                                    class="px-0"
                                    v-model="filters.client"
                                    label="text"
                                    :reduce="(returnValue) => (returnValue.id).toString()"
                                    :options="codeClients"
                                >
                                    <template v-slot:no-options>No se han encontrado resultados</template>
                                </v-select>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-wrapper mb-3">
                    <div class="form-group search-form">
                        <div class="row gx-2 w-100">
                            <div class="col-3">
                                <label
                                    class="form-label d-flex justify-content-center align-items-center bg-primary w-100 py-1 me-0 mb-0">
                                    Nombre cliente:
                                </label>
                            </div>

                            <div class="col-6">
                                <v-select
                                    class="px-0"
                                    v-model="filters.client"
                                    label="text"
                                    :reduce="(returnValue) => (returnValue.id).toString()"
                                    :options="nameClients"
                                    :filter="customFilterSearch"
                                >
                                    <template v-slot:no-options>No se han encontrado resultados</template>
                                </v-select>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-wrapper mb-3">
                    <div class="form-group search-form">
                        <div class="row gx-2 w-100">
                            <div class="col-3">
                                <label
                                    class="form-label d-flex justify-content-center align-items-center bg-primary w-100 py-1 me-0 mb-0">Entidad: </label>
                            </div>

                            <div class="col-6">
                                <v-select
                                    class="px-0"
                                    v-model="filters.entity"
                                    label="text"
                                    :reduce="(returnValue) => (returnValue.id)?.toString()"
                                    :options="nameEntities"
                                    :filter="customFilterSearch"
                                >
                                    <template v-slot:no-options>No se han encontrado resultados</template>
                                </v-select>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-wrapper mb-3">
                    <div class="form-group search-form">
                        <div class="row gx-2 w-100">
                            <div class="col-3 d-flex align-items-center">
                                <label
                                    class="form-label d-flex justify-content-center align-items-center bg-primary w-100 py-1 me-0 mb-0">
                                    Estado actual:
                                </label>
                            </div>

                            <div class="col-8">
                                <v-select
                                    class="w-100 px-0"
                                    v-model="filters.current_status"
                                    :value="filters.current_status"
                                    label="text"
                                    multiple
                                    :reduce="(returnValue) => (returnValue.id).toString()"
                                    :options="nameStatuses"
                                >
                                    <template v-slot:no-options>No se han encontrado resultados</template>
                                </v-select>
                            </div>

                            <div class="col-1 d-flex align-items-center">
                                <button class="btn btn-danger px-2 px-xxl-3 me-1"
                                        aria-label="Eliminar todos"
                                        title="Eliminar todos"
                                        @click="removeMultiselectAllOptions('current_status')">
                                    <span class="uq-icon bi-x"></span>
                                </button>

                                <button class="btn btn-secondary px-2 px-xxl-3"
                                        title="Añadir todos"
                                        @click="addMultiselectAllOptions('current_status', 'nameStatuses')">
                                    <span class="uq-icon bi-plus"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-wrapper mb-3">
                    <div class="form-group search-form">
                        <div class="row gx-2 w-100">
                            <div class="col-3 d-flex align-items-center">
                                <label
                                    class="form-label d-flex justify-content-center align-items-center bg-primary w-100 py-1 me-0 mb-0">Responsable: </label>
                            </div>

                            <div class="col-8">
                                <v-select
                                    class="w-100 px-0"
                                    v-model="filters.responsible"
                                    :value="filters.responsible"
                                    label="text"
                                    multiple
                                    :reduce="(returnValue) => (returnValue.id).toString()"
                                    :options="availableResponsibles"
                                >
                                    <template v-slot:no-options>No se han encontrado resultados</template>
                                </v-select>
                            </div>

                            <div class="col-1 d-flex align-items-center">
                                <button class="btn btn-danger px-2 px-xxl-3 me-1"
                                        aria-label="Eliminar todos"
                                        title="Eliminar todos"
                                        @click="removeMultiselectAllOptions('responsible')">
                                    <span class="uq-icon bi-x"></span>
                                </button>

                                <button class="btn btn-secondary px-2 px-xxl-3"
                                        title="Añadir todos"
                                        @click="addMultiselectAllOptions('responsible', 'availableResponsibles')">
                                    <span class="uq-icon bi-plus"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-container mb-0 py-0">
                <div class="form-wrapper mb-3">
                    <div class="form-group search-form">
                        <div class="row gx-2 w-100">
                            <div class="col-3 d-flex align-items-center">
                                <label
                                    class="form-label d-flex justify-content-center align-items-center bg-primary w-100 py-1 me-0 mb-0">
                                    Tipo de contrato:
                                </label>
                            </div>

                            <div class="col-8">
                                <v-select
                                    class="w-100 px-0"
                                    v-model="filters.contract_type"
                                    :value="filters.contract_type"
                                    label="text"
                                    multiple
                                    :reduce="(returnValue) => (returnValue.id).toString()"
                                    :options="availableContractTypes"
                                >
                                    <template v-slot:no-options>No se han encontrado resultados</template>
                                </v-select>
                            </div>

                            <div class="col-1 d-flex align-items-center">
                                <button class="btn btn-danger px-2 px-xxl-3 me-1"
                                        aria-label="Eliminar todos"
                                        title="Eliminar todos"
                                        @click="removeMultiselectAllOptions('contract_type')">
                                    <span class="uq-icon bi-x"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-wrapper mb-3">
                    <div class="form-group search-form">
                        <div class="row gx-2 w-100">
                            <div class="col-3 d-flex align-items-center">
                                <label
                                    class="form-label d-flex justify-content-center align-items-center bg-primary w-100 py-1 me-0 mb-0">
                                    Tipo de procedimiento:
                                </label>
                            </div>

                            <div class="col-8">
                                <v-select
                                    class="w-100 px-0"
                                    v-model="filters.procedure"
                                    :value="filters.procedure"
                                    label="text"
                                    multiple
                                    :reduce="(returnValue) => (returnValue.id).toString()"
                                    :options="availableProcedureTypes"
                                >
                                    <template v-slot:no-options>No se han encontrado resultados</template>
                                </v-select>
                            </div>

                            <div class="col-1 d-flex align-items-center">
                                <button class="btn btn-danger px-2 px-xxl-3 me-1"
                                        aria-label="Eliminar todos"
                                        title="Eliminar todos"
                                        @click="removeMultiselectAllOptions('procedure')">
                                    <span class="uq-icon bi-x"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-wrapper mb-3">
                    <div class="form-group search-form">
                        <div class="row gx-2 w-100">
                            <div class="col-3 d-flex align-items-center">
                                <label
                                    class="form-label d-flex justify-content-center align-items-center bg-primary w-100 py-1 me-0 mb-0">
                                    Tipo de demanda:
                                </label>
                            </div>

                            <div class="col-8">
                                <v-select
                                    class="w-100 px-0"
                                    v-model="filters.tipo_demanda"
                                    :value="filters.tipo_demanda"
                                    label="text"
                                    multiple
                                    :reduce="(returnValue) => (returnValue.id).toString()"
                                    :options="availableTipoDemandaTypes"
                                >
                                    <template v-slot:no-options>No se han encontrado resultados</template>
                                </v-select>
                            </div>

                            <div class="col-1 d-flex align-items-center">
                                <button class="btn btn-danger px-2 px-xxl-3 me-1"
                                        aria-label="Eliminar todos"
                                        title="Eliminar todos"
                                        @click="removeMultiselectAllOptions('tipo_demanda')">
                                    <span class="uq-icon bi-x"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="section-main">
            <v-table :meta="expedients.meta" :pagination="expedients.links.pagination" @pageChanged="pageChanged">
                <template v-slot:header>
                    <th>Nº cliente</th>
                    <th>Nombre cliente</th>
                    <th>Nombre exp.</th>
                    <th>Entidad</th>
                    <th>Tipo contrato</th>
                    <th>Tipo proc</th>
                    <th>Tipo demanda</th>
                    <th>Estado actual</th>
                    <th>Fecha est. act.</th>
                    <th>Responsable</th>
                    <th class="fit">
                        <button class="btn btn-download icon-wrapper"
                                @click="downloadExpedients(filters)">
                            <span class="uq-icon bi-download"></span>
                        </button>
                    </th>
                </template>

                <template v-slot:body>
                    <div class="loader" v-if="expedients_loading"></div>
                    <template v-else>
                        <tr v-for="expedient in expedients.data" :key="expedient.id">
                            <td class="clickable" @click="showClient(expedient.clients[0])">
                                <span class="colorize-hover">{{ expedient.clients[0].code }}</span>
                            </td>

                            <td class="clickable" @click="showClient(expedient.clients[0])">
                            <span class="colorize-hover">{{ expedient.clients[0].name }} {{
                                    expedient.clients[0].surname
                                }}</span>
                            </td>

                            <td>
                                <span class="badge bg-primary">{{ expedient.name }}</span>
                            </td>

                            <td class="clickable" @click="showEntity(expedient.entities[0])">
                                <span class="colorize-hover">{{ expedient.entities[0].short_name }}</span>
                            </td>

                            <td>
                                <span class="badge bg-secondary">{{ expedient.contract_type_display }}</span>
                            </td>

                            <td>
                                <span class="badge bg-info">{{
                                        expedient.form_values.tipo_procedimiento ? expedient.form_values.tipo_procedimiento : 'Sin valor'
                                    }}</span>
                            </td>

                            <td>
                                <span class="badge bg-info">{{
                                        expedient.form_values.tipo_demanda ? expedient.form_values.tipo_demanda : 'Sin valor'
                                    }}</span>
                            </td>

                            <td>
                                <span class="badge bg-success">{{ expedient.currentStatus.display_name }}</span>
                            </td>

                            <td>
                                <span class="badge bg-success">{{
                                        formatCurrentStatusDate(expedient.currentStatus, '/')
                                    }}</span>
                            </td>

                            <td class="clickable" @click="showResponsible(expedient)">
                            <span class="colorize-hover">
                                {{ expedient.responsible_display }}
                            </span>
                            </td>

                            <td class="fit">
                                <div class="actions-container">
                                    <button class="btn btn-edit"
                                            title="Ver historial de estados"
                                            @click="showExpedientStatusesTimeline(expedient)">
                                        <span class="uq-icon bi-clock-history"></span>
                                    </button>

                                    <router-link class="btn btn-show" title="Mostrar expediente"
                                                 :to="{ name: 'expedient.update', params: { expedient: expedient.id } }"
                                                 v-if="can('expedient.update')">
                                        <span class="uq-icon bi-search"></span>
                                    </router-link>

                                    <button class="btn btn-delete"
                                            @click="deleteExpedient(expedient)"
                                            v-if="can('expedient.destroy')">
                                        <span class="uq-icon bi-trash"></span>
                                    </button>
                                </div>
                            </td>
                        </tr>

                        <tr v-if="!expedients.data">
                            <td colspan="222222">No hay expedientes</td>
                        </tr>
                    </template>
                </template>
            </v-table>
        </div>

        <expedients-list-add-modal
            @closed="modalToShow = null; removeUrlQueryParameters(); filters.createExpedient = '';"
            :preselected_client="filters.client"
            :preselected_entity="filters.entity"
            @expedient-created="doSearch"
            v-if="modalToShow === 'add-expedient'">
        </expedients-list-add-modal>

        <expedients-list-delete-modal :expedient="expedient"
                                      @closed="modalToShow = null"
                                      @accepted="modalToShow = null; loadExpedients()"
                                      v-if="modalToShow === 'delete-expedient'">
        </expedients-list-delete-modal>

        <clients-list-show-modal :client="selectedClient"
                                 v-if="modalToShow === 'show-expedient-client'"
                                 @closed="modalToShow = null; selectedClient = null;">
        </clients-list-show-modal>

        <entities-list-show-modal :entity="selectedEntity"
                                  v-if="modalToShow === 'show-expedient-entity'"
                                  @closed="modalToShow = null; selectedEntity = null;">
        </entities-list-show-modal>

        <v-expedient-statuses-timeline-show-modal :client-number="selectedExpedient.clients[0].code"
                                                  :expedient-id="selectedExpedient.id"
                                                  :expedient-name="selectedExpedient.name"
                                                  v-if="modalToShow === 'show-expedient-statuses-timeline'"
                                                  @closed="modalToShow = null; selectedExpedient = null;"
                                                  @expedient-status-added="loadExpedients()"
                                                  @expedient-observations-updated="loadExpedients()"
        >
        </v-expedient-statuses-timeline-show-modal>

        <expedient-detail-change-responsible-modal v-if="modalToShow === 'change-responsible'"
                                                   :responsible="this.selectedExpedient.responsible"
                                                   @closed="modalToShow = null;"
                                                   @responsible-changed="updateExpedientResponsible">
        </expedient-detail-change-responsible-modal>
    </div>

    <div v-if="status === 'loading'">
        <div class="loader-container">
            <div class="loader"></div>
        </div>
    </div>
</template>

<script>

import { can } from "../../helpers/Permissions";
import ExpedientsListAddModal from "./parts/ExpedientsListAddModal";
import ExpedientsListDeleteModal from "./parts/ExpedientsListDeleteModal";
import TheNav from "../layouts/TheNav";
import {
    getContractTypes,
    getExpedientsPaginated,
    getResponsibles,
    updateExpedientResponsible
} from "../../helpers/requests/RequestsExpedients";
import router from "../../router";
import { downloadExpedientsXLSX, downloadSeguimientoExpedientesXLSX } from "../../helpers/Exports";
import { apiGET, withTimeout } from "../../helpers/requests/RequestsCore";
import VPagination from "../general/VPagination";
import { filtersToQueryParameters, setQueryParameters } from "../../helpers/Url";
import ClientsListShowModal from "../clients/parts/ClientsListShowModal";
import EntitiesListShowModal from "../entities/parts/EntitiesListShowModal";
import { getCurrentStatus } from "../../helpers/Expedient";
import VModal from "../general/VModal";
import VExpedientStatusesTimelineShowModal from "./parts/expedient-detail-parts/VExpedientStatusesTimelineShowModal";
import VTable from "../general/VTable";
import { getAllStatuses } from "../../helpers/requests/RequestsStatuses";
import { getAllClientsWithoutPagination } from "../../helpers/requests/RequestsClients";
import { getAllEntitiesWithoutPagination } from "../../helpers/requests/RequestsEntities";
import ExpedientDetailChangeResponsibleModal
    from "./parts/expedient-detail-parts/ExpedientDetailChangeResponsibleModal";
import VMultiSelectJQ from "../general/VMultiSelectJQ";
import vSelect from 'vue-select';


export default {
    name: "ExpedientsList",
    components: {
        VMultiSelectJQ,
        ExpedientDetailChangeResponsibleModal,
        VExpedientStatusesTimelineShowModal,
        VModal,
        EntitiesListShowModal,
        ClientsListShowModal,
        VPagination,
        TheNav,
        ExpedientsListDeleteModal,
        ExpedientsListAddModal,
        VTable,
        vSelect,
    },
    setup() {
        return {
            can,
            getCurrentStatus,

            downloadSeguimientoExpedientesXLSX,
            downloadExpedientsXLSX,
        }
    },
    data() {
        return {
            status: 'loading',
            expedients_loading: true,
            expedients: [],
            expedient: null,
            expedientId: null,
            modalToShow: null,

            selectedClient: null,
            selectedEntity: null,
            selectedExpedient: null,

            availableClients: [],
            availableEntities: [],
            availableResponsibles: [],
            availableStatuses: [],
            availableContractTypes: [],
            availableProcedureTypes: [
                { id: 'Procedimiento Ordinario', text: 'Procedimiento Ordinario' },
                { id: 'Monitorio', text: 'Monitorio' },
                { id: 'Juicio Verbal', text: 'Juicio Verbal' },
                { id: 'Apelación', text: 'Apelación' },
                { id: 'Oposición', text: 'Oposición' },
                { id: 'Ejecución de sentencia', text: 'Ejecución de sentencia' }
            ],
            availableTipoDemandaTypes: [
                { id: 'Suelo', text: 'Suelo' },
                { id: 'IRPH', text: 'IRPH' },
                { id: 'Gastos hipotecarios', text: 'Gastos hipotecarios' },
                { id: 'Comisión Apertura', text: 'Comisión Apertura' },
                { id: 'Rendición de cuentas', text: 'Rendición de cuentas' },
                { id: 'Usura o Transparencia', text: 'Usura o Transparencia' },
                { id: 'Posiciones deudoras', text: 'Posiciones deudoras' },
                { id: 'Derecho al Honor', text: 'Derecho al Honor' },
                { id: 'Otros', text: 'Otros' },
            ],

            codeClients: [],
            nameClients: [],
            nameEntities: [],
            nameStatuses: [],

            // This is used only when coming from other view and want to create a new expedient
            create_new_expedient: false,

            do_search: true,

            doHandleSeguimientoDownload: false,

            filters: {
                client: '',
                entity: '',
                current_status: [],
                responsible: [],
                contract_type: [],
                procedure: [],
                page: 1,
            },
            timers: {
                search: ''
            },
            cancelToken: undefined,
            showFilters: true,
        }
    },
    async mounted() {
        window.$ = window.jQuery = require('jquery');

        if (can('export.seguimiento-expedientes')) {
            window.setInterval(() => {
                if (this.doHandleSeguimientoDownload) {
                    this.downloadSeguimientos()
                }
            }, 10000)
        }

        await Promise.all([
            this.loadAvailableClients(),
            this.loadAvailableEntities(),
            this.loadAvailableStatuses(),
            this.loadAvailableResponsibles(),
            this.loadAvailableContractTypes(),
        ]);

        // Read query params to form filters
        await this.setQueryParametersAsFilters();
        await this.doSearch();
        this.status = 'loaded';
    },
    watch: {
        filters: {
            handler(newValue, oldValue) {
                this.doSearch();
            },
            deep: true
        },
        $route(to, from) {
            // Apply only if we are operating over the same view
            if (to.name === from.name) {
                // TODO: Watch this and just only change url query parameters when methods fire something? This will do the rest
                this.setQueryParametersAsFilters();

                // We force it to not search because of a two-requests problem
                if (this.do_search === true) {
                    this.doSearch();
                }

                this.do_search = true;
            }
        }
    },
    methods: {
        async downloadSeguimientos(filters, isClientRequest = false) {
            const resp = await apiGET('api/excel/seguimiento-expedientes-status');

            switch (resp.value) {
                case 'loading':
                    // As it is being processed, we need to set the button as disabled
                    if (!this.doHandleSeguimientoDownload) {
                        this.$store.dispatch('app/setToastMessage', 'Procesando la descarga... Esto puede tardar unos minutos.');
                    } else {
                        if (isClientRequest) {
                            this.$store.dispatch('app/setToastMessage', 'Su descarga está siendo procesada. Por favor, espere.');
                        }
                    }

                    this.doHandleSeguimientoDownload = true;
                    break;
                case 'ready':
                    // It is ready to be downloaded, so lets enable the button
                    await downloadSeguimientoExpedientesXLSX(filters);
                    this.$store.dispatch('app/setToastMessage', 'Se ha descargado el fichero con éxito.');

                    this.doHandleSeguimientoDownload = false;
                    break;
                case 'downloaded':
                case 'failed':
                    // It's been downloaded, so restart again and call the process to restart the worker
                    if (!this.doHandleSeguimientoDownload) {
                        this.$store.dispatch('app/setToastMessage', 'Procesando la descarga... Esto puede tardar unos minutos.');
                    } else {
                        if (isClientRequest) {
                            this.$store.dispatch('app/setToastMessage', 'Su descarga está siendo procesada. Por favor, espere.');
                        }
                    }

                    this.doHandleSeguimientoDownload = true;

                    // Force to regenerate file as user clicked on it
                    await downloadSeguimientoExpedientesXLSX(filters);
            }
        },
        async downloadExpedients(filters) {
            this.$store.dispatch('app/setToastMessage', 'Procesando la descarga...');
            downloadExpedientsXLSX(filters);
        },

        async loadAvailableClients() {
            let clients = await getAllClientsWithoutPagination();

            if (!clients.meta) {
                this.availableClients = clients;

                this.codeClients = Object.values(clients).map((client) => {
                    return { id: client.id, text: client.code }
                });

                this.nameClients = Object.values(clients).map((client) => {
                    return { id: client.id, text: client.fullName }
                });
            }
        },
        async loadAvailableEntities() {
            let entities = await getAllEntitiesWithoutPagination();
            if (!entities.meta) {
                this.availableEntities = entities;

                this.nameEntities = Object.values(entities).map((entity) => {
                    return { id: entity.id, text: entity.name + ' (' + entity.short_name + ')' };
                });
            }
        },
        async loadAvailableStatuses() {
            this.availableStatuses = await getAllStatuses();

            // We manually add '*Sin estado' to be able to filter by that state
            this.availableStatuses.unshift({
                key: "stateless",
                value: "*Sin estado"
            });

            this.nameStatuses = Object.values(this.availableStatuses).map((status) => {
                return { id: status.key, text: status.value }
            });
        },
        async loadAvailableResponsibles() {
            let responsibles = await getResponsibles();

            this.availableResponsibles = Object.values(responsibles).map((responsible) => {
                return { id: responsible.key, text: responsible.value }
            });
        },
        async loadAvailableContractTypes() {
            let contractTypes = await getContractTypes();

            this.availableContractTypes = Object.values(contractTypes).map((contract_type) => {
                return { id: contract_type.key, text: contract_type.value }
            });
        },
        showExpedientStatusesTimeline(expedient) {
            this.selectedExpedient = expedient;
            this.modalToShow = 'show-expedient-statuses-timeline';
        },
        async doSearch() {
            this.do_search = false;
            await this.setFiltersAsQueryParameters();
            await this.loadExpedients();
        },
        emptyFilters() {
            this.filters = {
                client: '',
                entity: '',
                current_status: [],
                responsible: [],
                contract_type: [],
                procedure: [],
                tipo_demanda: [],
                page: 1,
            };

            // FIXME: Limpiar etiquetas sin tener que llamar al metodo de VMultiSelectJQ
            this.$refs.multiselectStatus.removeAll();
            this.$refs.multiselectResponsible.removeAll();
            this.$refs.multiselectContractType.removeAll();
            this.$refs.multiselectProcedure.removeAll();
            this.$refs.multiselectTipoDemanda.removeAll();

            this.doSearch();
        },
        /**
         * Detects any query parameter in the url and loads it in the filters (if available)
         *
         * @returns {Promise<void>}
         */
        async setQueryParametersAsFilters() {
            let query_parameters = router.currentRoute.value.query;

            if (query_parameters.client) {
                this.filters.client = query_parameters.client;
            } else {
                this.filters.client = '';
            }

            if (query_parameters.entity) {
                this.filters.entity = query_parameters.entity;
            } else {
                this.filters.entity = '';
            }

            if (query_parameters.current_status) {
                this.filters.current_status = query_parameters.current_status;
            } else {
                this.filters.current_status = [];
            }

            if (query_parameters.responsible) {
                this.filters.responsible = query_parameters.responsible;
            } else {
                this.filters.responsible = [];
            }

            if (query_parameters.contract_type) {
                this.filters.contract_type = query_parameters.contract_type;
            } else {
                this.filters.contract_type = [];
            }

            if (query_parameters.procedure) {
                this.filters.procedure = query_parameters.procedure;
            } else {
                this.filters.procedure = [];
            }

            if (query_parameters.tipo_demanda) {
                this.filters.tipo_demanda = query_parameters.tipo_demanda;
            } else {
                this.filters.tipo_demanda = [];
            }

            // Create new expedient
            if (query_parameters.createExpedient === 'true') {
                this.filters.createExpedient = query_parameters.createExpedient;
                this.modalToShow = 'add-expedient';
            } else {
                this.filters.createExpedient = '';
                this.modalToShow = '';
            }
        },
        /**
         * Sets the local filters as url query parameters.
         */
        setFiltersAsQueryParameters() {
            setQueryParameters('expedient.index', this.filters);
        },
        async loadExpedients() {
            this.expedients_loading = true;

            if (this.cancelToken !== undefined) {
                this.cancelToken.cancel();
            }

            this.cancelToken = axios.CancelToken.source();

            let query = filtersToQueryParameters(this.filters);

            try {
                this.expedients = await getExpedientsPaginated(query, this.cancelToken.token);

                this.expedients_loading = false;
            } catch (e) {
                if (!axios.isCancel(e)) {
                    this.cancelToken = undefined;

                    throw e;
                }
            }
        },
        async updateExpedientResponsible(responsible) {
            this.$store.dispatch('app/setToastMessage', 'Cambiando el responsable...');

            await updateExpedientResponsible(this.selectedExpedient.id, responsible);
            await this.loadExpedients();

            this.$store.dispatch('app/setToastMessage', 'Responsable cambiado con éxito');
            this.modalToShow = null;
        },
        removeUrlQueryParameters() {
            // TODO: Delete the 'addExpedient' url query parameter
            let query_parameters = router.currentRoute.value.query;
            let new_query = {};
            for (let i in query_parameters) {
                if (i !== 'createExpedient') {
                    new_query[i] = query_parameters[i];
                }
            }

            router.push({
                name: 'expedient.index',
                query: new_query
            });
        },
        search() {
            this.timers.search = withTimeout(async () => {
                this.filters.page = 1;
                await this.doSearch();
            }, this.timers.search, 250);
        },
        async pageChanged(page) {
            this.filters.page = page;
            await this.doSearch();
        },
        showExpedient(id) {
            this.modalToShow = 'show-expedient';
            this.expedientId = id;
        },
        deleteExpedient(expedient) {
            this.modalToShow = 'delete-expedient';
            this.expedient = expedient;
        },
        addExpedient() {
            this.modalToShow = 'add-expedient';
        },
        showClient(client) {
            this.modalToShow = 'show-expedient-client';
            this.selectedClient = client;
        },
        showEntity(entity) {
            this.modalToShow = 'show-expedient-entity';
            this.selectedEntity = entity;
        },
        showResponsible(expedient) {
            this.selectedExpedient = expedient;
            this.modalToShow = 'change-responsible';
        },
        formatCurrentStatusName(statuses) {
            let str = "";
            let status = this.getCurrentStatus(statuses);

            if (status === null) {
                str = '*Sin estado';
            } else {
                str = status.display_name;
            }

            return str;
        },
        formatCurrentStatusDate(status, separator = '-') {
            let str = "";

            if (status === null) {
                str = '*Sin fecha';
            } else {
                let d = status.date.split(' ')[0].split('-');
                str = d[2] + separator + d[1] + separator + d[0];
            }

            return str;
        },
        addMultiselectAllOptions(variable, options) {
            const values = [];
            for (let key in this[options]) {
                let status = this[options][key].id;
                values.push(status);
            }

            this.filters[variable] = values;
            this.search();
        },
        removeMultiselectAllOptions(variable) {
            this.filters[variable] = [];

            this.search();
        },
        removeDiacritics(text) {
            text.text ? text = text.text : text;
            return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        },
        normalizedContains(needle, haystack) {
            const regExp = new RegExp(this.removeDiacritics(needle), 'gi');
            return regExp.test(this.removeDiacritics(haystack));
        },
        customFilterSearch(options, search) {
            return search ?
                options.filter(option => this.normalizedContains(search, option))
                : options;
        }
    },
    unmounted() {
        delete window.$;
        delete window.jQuery;
    }
}
</script>

<style lang="scss" scoped>
.search-form {
    .form-label {
        border-radius: .25rem;
        color: #FFFFFF;
    }
}
</style>
